import { SkeletonSectionType } from 'components/skeleton/enums/skeleton-section-type.enum';

import ComingSoonBadge from 'components/comingSoonBadge/ComingSoonBadge';
import Page from 'components/page/Page';
import PageWrapper from 'components/pageWrapper/PageWrapper';
import { Skeleton } from 'components/skeleton/components/Skeleton';

import styles from './MarketSkeleton.module.scss';

const MarketSkeleton = () => {
  const nftCardsMockCount = 200;

  return (
    <Page requireTermsOfServiceConsents pageBackground="dark" className={styles['page']}>
      <PageWrapper homeFooter={false}>
        <div className={styles['wrapper']}>
          <div className={styles['sidebar']}>
            <Skeleton
              rows={[
                [
                  SkeletonSectionType.filter,
                  SkeletonSectionType.filter,
                  SkeletonSectionType.filter,
                  SkeletonSectionType.filter,
                ],
              ]}
            />
          </div>
          <div className={styles['content']}>
            <ComingSoonBadge className={styles['list-skeleton-counter']} />
            <Skeleton
              className={styles['list-skeleton']}
              rows={[new Array(nftCardsMockCount).fill(0).map(() => SkeletonSectionType.nftCard)]}
            />
          </div>
        </div>
      </PageWrapper>
    </Page>
  );
};

export default MarketSkeleton;
